import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";

@Component({
  selector: 'advance-dialog',
  templateUrl: './advance.component.html',
  styleUrls: ['./advance.component.css']
})
export class AdvanceDialog implements OnInit {

  public account: any;
  public total: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.account = data.payment.description;
    this.total = data.total;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/checkout/dialog/advance/advance.component.ts